// extracted by mini-css-extract-plugin
module.exports = {"sheet":"styles_sheet__1osxM","cardBody":"styles_cardBody__aBGk1","subtitle":"styles_subtitle__3fTIA","cardFooter":"styles_cardFooter__246xe","button":"styles_button__375zK"};